import axiosUmbraco from "../../../axios/axiosUmbraco";
import { formatDate } from "../../../helper/formatDate";

const pageId = process.env.REACT_APP_GALLARY_ID;
export function getAlbums(id = pageId) {
    return new Promise((resolve, reject) => {
        axiosUmbraco.get(`/umbraco/delivery/api/v2/content?fetch=children:${id}&skip=0&take=1000`).then(res => {
            if (res.status == 200) {
                const sortedData = res.data.items.sort((a, b) => new Date(b?.properties?.eventStartDate) - new Date(a?.properties?.eventStartDate));
                const formattedData = sortedData.map((item) => ({
                    albumName: item?.properties?.albumName?.toLowerCase() ?? "",
                    albumMedia: item?.properties?.albumCover ?? [],
                    albumId: item?.id ?? '',
                    albumStartDate: formatDate(item?.properties?.eventStartDate) ?? '',
                    albumEndDate: formatDate(item?.properties?.eventEndDate) ?? "",
                    eventId: item?.properties?.eventId ?? "",
                    season: item?.properties?.season ? item?.properties?.season : "2024"
                }));
                resolve(formattedData);
            }
            resolve(false);
        }).catch(error => reject(false))
    })
}
